<button 
  class="btn btn-outline-secondary dropdown-toggle" 
  type="button" 
  data-toggle="dropdown"
  [attr.disabled]="loading ? 'DISABLED' : null"
>
  {{ displayName }}
</button>
<div class="dropdown-menu p-3">
  <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="query" (keyup)="search()"/>
  <div role="separator" class="dropdown-divider"></div>
  <div class="text-center" *ngIf="criteriaLoading">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Chargement...
  </div>
  <div class="text-center" *ngIf="results != undefined && results.content.length == 0">Aucun {{ displayName | lowercase }} trouvé</div>
  <div class="results" *ngIf="results">
    <a class="dropdown-item" *ngFor="let result of results.content" (click)="addFilter(result)">{{ formatResult(result) }}</a>
  </div>
  <div class="text-center border-top pt-2" *ngIf="results != undefined &amp;&amp; results.content.length != 0">
    {{ results.numberOfElements }} {{ formatResultsMetadataLabel() }} {{ results.totalElements }}
  </div>
</div>